import { useFormContext } from 'react-hook-form';
import { LwFormMultiSelect } from 'redesign';
import { useCallback } from 'react';
import { Chip, createFilterOptions, styled } from '@mui/material';
import { TimeSlotFormContext, WorkerOptions } from './time-slot.types';

export const AvailabilityWorkersMultiselect = ({
  disabled,
  workerOptions,
}: {
  disabled: boolean;
  workerOptions: WorkerOptions[];
}) => {
  const { control } = useFormContext<TimeSlotFormContext>();
  const filterOptions = useCallback(
    createFilterOptions({
      stringify: ({ name, description }: WorkerOptions) => `${name} ${description ?? ''}`,
    }),
    []
  );

  return (
    <LwFormMultiSelect
      name={`workerOptions`}
      control={control}
      disabled={disabled}
      label="Selecteer de gewenste flexwerker(s)"
      rules={{ required: 'Voer een flexwerker in' }}
      options={workerOptions}
      getOptionKey={(option: WorkerOptions) => option.id}
      getOptionLabel={(option: WorkerOptions) => option.name}
      renderOption={(props, option) => (
        <Option {...props} key={option.id}>
          <Chip label={option.name}></Chip>
          {option.description ? option.description : null}
        </Option>
      )}
      filterOptions={filterOptions}
      noOptionsText="Aan dit geselecteerde functietype zijn geen partnerrelaties gekoppeld"
    />
  );
};

const Option = styled('li')(({ theme }) => ({
  '.MuiChip-root': {
    backgroundColor: theme.palette.lwPrimary[10],
    marginBottom: 0,
    borderRadius: theme.spacing(6),
  },
  '.MuiChip-label': {
    color: theme.palette.lwPrimary[100],
  },
}));
